import { useState } from 'react';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    setSelectedCategory(url);
    if (url) {
      window.open(url, '_blank', 'noopener,nofollow');
    }
  };

  return (
    <section id="home" className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image - unique fashion/shopping themed */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylish%20modern%20fashion%20boutique%20interior%20with%20elegant%20clothing%20display%20racks%20and%20warm%20ambient%20lighting%2C%20luxury%20retail%20space%20with%20wooden%20floors%20and%20cream%20walls%2C%20soft%20golden%20spotlights%2C%20premium%20shopping%20atmosphere%2C%20editorial%20interior%20photography%20style%2C%20warm%20inviting%20tones%2C%20high-end%20aesthetic&width=1800&height=1000&seq=hero-fashion-2026&orientation=landscape"
          alt="BaseTao Spreadsheet fashion research hub"
          title="BaseTao Spreadsheet Hub - Research Platform"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50 z-[1]"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-xs md:text-sm font-medium text-background-50">Updated August 2026</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5 drop-shadow-sm">
          The Complete <span className="text-primary-300">BaseTao Spreadsheet</span> Resource Hub
        </h1>

        <p className="text-sm md:text-lg text-background-50/90 max-w-2xl mx-auto mb-8 leading-relaxed drop-shadow-sm">
          Everything you need to understand BaseTao Spreadsheet — from product research, shipping costs, warehouse management, reviews, coupons, and buying strategies.
        </p>

        {/* Category Dropdown */}
        <div className="max-w-md mx-auto mb-6">
          <label htmlFor="category-select" className="block text-xs font-medium text-background-50/80 mb-2 text-left uppercase tracking-wider drop-shadow-sm">
            Browse Categories
          </label>
          <div className="relative">
            <select
              id="category-select"
              value={selectedCategory}
              onChange={handleSelectChange}
              className="w-full appearance-none bg-background-50/15 backdrop-blur-md border border-background-50/30 text-background-50 text-sm rounded-xl px-5 py-3.5 pr-12 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400/50 transition-all"
            >
              <option value="" className="text-foreground-900">Select a product category...</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url} className="text-foreground-900">
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-background-50 text-lg"></i>
            </div>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer drop-shadow-sm"
            target="_blank"
            rel="noopener nofollow"
          >
            <i className="ri-book-open-line mr-2"></i>
            Explore BaseTao Spreadsheet Guides
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/20 backdrop-blur-md border border-background-50/40 text-background-50 font-semibold text-sm rounded-full hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer drop-shadow-sm"
          >
            <i className="ri-external-link-line mr-2"></i>
            Visit Main Website
          </a>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 mt-10">
          {[
            { icon: 'ri-checkbox-circle-line', text: 'Updated 2026 Guides' },
            { icon: 'ri-user-star-line', text: 'Real Buyer Research' },
            { icon: 'ri-ship-line', text: 'Shipping Comparison' },
            { icon: 'ri-shield-check-line', text: 'Security Focused' },
          ].map((badge) => (
            <div key={badge.text} className="flex items-center gap-2 text-background-50/80 text-xs md:text-sm drop-shadow-sm">
              <i className={`${badge.icon} text-accent-400 text-sm`}></i>
              <span className="whitespace-nowrap">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}